<template>
  <div class="dowload-app-tips" v-if="show && !isYixinliApp">
    <a
      href="https://m.xinli001.com/download"
      alt="下载壹心理App"
      class="btns-down"
      @click="buttonDownload"
    >
      立即加入
    </a>
    <a
      href="javascript:void(0);"
      class="close"
      v-if="isCloseAllowed"
      @click="close"
    >
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAAAXNSR0IArs4c6QAAAdBJREFUSA2tVbtKA0EUzW7ESNIJgmUendj4A6IgFvkF8QvyAVql1l4srP0BG20koo2NYJsmry6VhWDSmF3PWXKX7GRmcjd4Ybgz93HO3rkzs4XCP8tgMDjC2BXYUCbU4/G4MhqN9hZteeb9fv80juMnjBchCQSA4JPJ5BHr/TAMT6rV6qf4NJrgiHsA+BbjgyDoYhwnBAIO5+Hc+ZWHxAQnBgUE58kWTafTMwGnA/PtKIqeh8PhAdc+cYEjp1Wv1+8TglqtdgfD9SKQhsQH3mg0bomX9oCLXq93BXXBuQjKtG6XBpwYGQIaNCRacCvBKhL0Zgcx6Wlh/Fxasi1ioF6qQJyOSr7hL6E/JYmbays4fU4COm0ktBviBGecl4ABK0i84MzPPBU0mIJT1IHt12L/KRaL76bdXHsJ5LQgacNMRB8qmsvo3CIBB1DytpgEsnbdE/FbK/CAt5CY68YvVeADl3Nua7yrkgyBBlxK15KkBHnA85AkBOuAa0kCnJIQv7cPaPPtX3mJNCQhmhNhNDG6kgCtBmcOmn8JtXS6ZrNZO+0Bf9KoooNxI6eFyXlksfH44LdyudzM5APcfCUzfs2CJOjpK//zmvi1YvChm5L4B0tOP1l4NhhUAAAAAElFTkSuQmCC"
      />
    </a>
    <!--<a v-else href="javascript:void(0);" class="close"></a>-->
    <a
      href="https://m.xinli001.com/download"
      alt="下载壹心理App"
      class="dls-link"
      @click="logoDownload"
    >
      <img
        class="app-icon"
        src="https://lapp.xinli001.com/images/logo/logo9.png"
        alt="壹心理App"
      />
      <div class="desc">
        <span class="purple">壹心理App</span>
        <span>与2000万年轻人一起自我成长</span>
      </div>
    </a>
  </div>
</template>

<script>
import cookies from 'lib/tools/cookies'
// import { goApp } from "lib/tools/utils"

export default {
  computed: {
    isYixinliApp() {
      return this.$platform.isYixinliApp
    }
  },
  data() {
    return {
      show: false
    }
  },
  props: {
    isCloseAllowed: {
      type: Boolean,
      default: true
    },
    isCustomFunction: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.show = !cookies.getCookie('m-topBar-ad')
  },
  methods: {
    logoDownload(e) {
      e.preventDefault()
      // 埋点
      this.$stat.send({
        name: '文章-交互行为',
        properties: {
          业务: '文章',
          行为: '点击',
          对象: '文章详情页-顶部下载栏-logo图标',
          文字: '壹心理App，与2000万年轻人一起自我成长'
        }
      })

      // 判断是否自定义事件
      if (this.isCustomFunction) {
        this.$emit('customFun')
      } else {
        this.downloadApp()
      }
    },
    buttonDownload(e) {
      e.preventDefault()
      // 埋点
      this.$stat.send({
        name: '文章-交互行为',
        properties: {
          业务: '文章',
          行为: '点击',
          对象: '文章详情页-顶部下载栏-文字按钮',
          文字: '立即加入'
        }
      })

      // 判断是否自定义事件
      if (this.isCustomFunction) {
        this.$emit('customFun')
      } else {
        this.downloadApp()
      }
    },
    downloadApp() {
      // 如果是IOS，直接调起Apple Store
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.location.href =
          'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
      } else {
        window.location.href = `https://m.xinli001.com/download`
      }
    },
    close() {
      cookies.setCookie({
        key: 'm-topBar-ad',
        value: true,
        timeMinSec: 5 * 24 * 60 * 60 * 1000 // 5天
      })
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dowload-app-tips {
  font-family: PingFangSC-Regular;
  width: 100%;
  background: #edf1f5;
  .close {
    float: left;
    width: 24px;
    height: 25px;
    padding: 15px;
    margin: 22.5px 0;
    background: 0 0;
    img {
      width: 100%;
      vertical-align: top;
    }
  }
  .dls-link {
    display: block;
    height: 100px;
    -webkit-background-size: cover;
    background-size: cover;
    text-align: left;
    .desc {
      display: inline-block;
      vertical-align: top;
      box-sizing: border-box;
      height: 64px;
      margin: 10px 4px 20px 20px;

      span {
        display: block;
        font-size: 24px;
        color: #333;
        &.bule {
          font-size: 32px;
          color: #0f8eff;
          margin-right: 8px;
          font-weight: 700;
        }
        &.purple {
          font-size: 32px;
          color: #6982fa;
          margin-right: 8px;
          font-weight: 700;
        }
      }
    }
  }
  .btns-down {
    float: right;
    width: 112px;
    height: 50px;
    line-height: 56px;
    margin: 22.5px 10px 22.5px 0;
    text-align: center;
    border: 1px solid #6982fa;
    color: #6982fa;
    font-size: 24px;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    background: 0 0;
  }
  .app-icon {
    margin: 20px 4px 20px 20px;
    vertical-align: top;
    display: inline-block;
    width: 64px;
    height: 64px;
  }
}
</style>
